import { useEffect, useState } from "react";

interface IWindowState {
    width: number | undefined;
    height: number | undefined;
}

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState<IWindowState>({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
}